import { render, staticRenderFns } from "./AlphabetIndex.vue?vue&type=template&id=552541a4&scoped=true&"
import script from "./AlphabetIndex.vue?vue&type=script&lang=ts&"
export * from "./AlphabetIndex.vue?vue&type=script&lang=ts&"
import style0 from "./AlphabetIndex.vue?vue&type=style&index=0&id=552541a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552541a4",
  null
  
)

export default component.exports